export const home = '/'
export const signin = '/signin'
export const forgotpassword = '/forgotpassword'
export const resetpassword = '/reset-password'
export const candidatemanagement = '/candidatemanagement'
export const employermanagement = '/employermanagement'
export const jobopeningmanagement = '/jobopeningmanagement'
export const jobapplicationmanagement = '/jobapplicationmanagement'
export const privacypolicy = '/privacypolicy'
export const myaccount = '/myaccount'
export const editprofile = '/dashboard/myaccount/editprofile'
export const changepassword = '/dashboard/myaccount/changepassword'
export const viewjobapplication = '/viewjobapplication'
export const cmseditor = '/cmseditor'
export const jobreport = '/jobreport'
export const viewusermanagment = '/viewusermanagment'
export const employerview = '/employerview'
export const jobopeningview = '/jobopeningview'
export const industrymanagement = '/industrymanagement'
export const addnewindustry = '/addnewindustry'
export const countrymanagement = '/countrymanagement'
export const addnewcountry = '/addnewcountry'
export const statemanagement = '/statemanagement'
export const addnewstate = '/addnewstate'
export const citymanagement = '/citymanagement'
export const addnewcity = '/addnewcity'
export const viewTeam = "/viewteam"
export const Termsandcondition = '/Termsandcondition'
export const viewCV = '/viewCV'
export const category = '/job-category'
export const faqcategory = "/faq-category"
export const faqaddeditsubcategory ="/faq-addedit-subcategory"
export const faqsubcategory = "/faq-subcategory"
export const compliance = "/compliance"
export const creatnewopening = "/creatnewopening"
export const faq = "/faq-management"
export const appointments= "/appointments"
export const clientAppointment = "/client-appointment"
export const blogs ="/manage-blogs"
export const createnewblog = "/create-blog"
export const contactus="/contactus"
export const testimonial ="/testimonial"
export const gdprpolicy="/gdpr-policy"
export const esgpolicy="/esg-policy"
export const genderpaygap="/gender-pay-gap"
export const carbonreductionplan="/carbon-reduction-plan"
export const modernslaveryact ="/modern-slavery-act"
export const viewblog = "/viewblog"
export const jobalert = '/jobalert'
export const clientpartner = 'client-partner'
export const viewjobopening = '/view-job-opening'
export const viewfaq = '/viewfaq'


export const addeditfaq = "/faq-addedit"

